





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Photograph, PhotosApi, ValidationProblemDetails } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    photosApi: 'photosApi'
  })
})
export default class DeletePhoto extends Vue {
  private photosApi!: PhotosApi;

  @Prop({ required: true })
  private photo!: Photograph;

  private deletePhotoPopoverTippy = false;
  private isLoading = false;

  private async deletePhoto() {
    if (this.photo.workorderId && this.photo.photoId) {
      this.isLoading = true;
      try {
        var photoId = this.photo.photoId;
        await this.photosApi.deletePhotoById({ photoId });
        this.isLoading = false;
        this.$emit('photo-deleted');
      } catch (error) {
        this.editorError(error);
      }
    }
    this.isLoading = false;
    this.deletePhotoPopoverTippy = false;
  }

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }

    if (vpd.errors) {
      alert(vpd.errors[''][0]);
    }
  }
}
